export default __webpack_public_path__ + "static/media/brian-chan-NbXjZomyNEM-unsplash.149bbea6.jpg";